import { useQuery } from "@tanstack/react-query";
import { getProfileStats } from "../api/profile";

export function useProfileStats(enabled = true) {
  return useQuery({
    queryKey: ["tawa", "profile", "stats"],
    queryFn: getProfileStats,
    enabled,
    staleTime: 60_000,
  });
}
